import React, { useState } from "react";
import {
  Button,
  Modal,
  Table
} from "react-bootstrap";
import { stringDateTimeReceipt } from "../Utility/dateTime";
import { formatCurrency, summary } from "../Utility/function";
import { normalSort } from "../Utility/sort";
import { useTranslation } from 'react-i18next';


function Modal_Shift({
  backdrop=true, // true/false/static
  animation=true,
  show,
  onHide,
  centered=true,
  current,
}) {
  const { t } = useTranslation();
  const [translate] = useState({
    1:t('mShift.inbound'),
    2:t('mShift.outbound')
  })
  const {
    thisVat,
    thisPayment,
    thisCategory,
    thisCashier,
    thisSelectedQty,
    thisVoidQty,
    saleRate,
    thisTotalNet,
    thisProduct,
    closeName,
    openTime,
    shiftCount, closeTime, closeCash, closeWithDraw, closeDiff, currentCash, cashRemain,
    duringShift,
    totalManualDiscount,
    totalPointDiscount,
    totalProductDiscount,
    thisCampaign
 } = current;


  return (
    <Modal
      backdrop={backdrop}
      animation={animation}
      show={show}
      onHide={onHide}
      centered={centered}
      // size={size}
      fullscreen={true}
    >
       
      <Modal.Header closeButton>
        <h2><b>{t('mShift.history')}</b></h2>
      </Modal.Header>

      <Modal.Body  >
            <h4>{t('mShift.shift',{ shiftCount })}</h4>
            <h6>{t('mShift.openTime')}{stringDateTimeReceipt(openTime) }</h6>
            <h6>{t('mShift.endTime')}{stringDateTimeReceipt(closeTime)}</h6>
            <h6>{t('mShift.closeShiftBy',{ closeName })}</h6>
            <h6>{t('mShift.cashInDrawer')} {formatCurrency(currentCash)}</h6>
            <h6>{t('mShift.countCash')} {formatCurrency(Number(closeCash))}</h6>
            <h6>{t('mShift.cashWithDraw')} {formatCurrency(Number(closeWithDraw))}</h6>
            <h6>{t('mShift.remainInDrawer')} {formatCurrency(cashRemain)}</h6>
            <h6>{t('mShift.diff')}{formatCurrency(closeDiff)}</h6>
            {duringShift.length>0
                ?<React.Fragment>
                  <h4>{t('mShift.duringShift')}</h4>
                    <Table striped bordered hover responsive  variant="light"   >
                      <thead  >
                        <tr>
                          <th style={styles.text} >No.</th>
                          <th style={styles.text2} >{t('mShift.list')}</th>
                          <th style={styles.text2} >{t('mShift.amount')}</th>
                          <th style={styles.text2} >{t('mShift.staff')}</th>
                          <th style={styles.text2} >{t('mShift.reason')}</th>
                          <th style={styles.text2} >{t('mShift.time')}</th>
                        </tr>
                      </thead>
                      <tbody  >
                 
                        {duringShift.map((item, index) => {
                          const { type, amount, staff, comment, timestamp } = item;
                          return <tr  key={index} >
                                    <td style={styles.text}>{index+1}.</td>
                                    <td style={styles.text2}>{translate[type]}</td>
                                    <td style={styles.text2}>{amount}</td>
                                    <td style={styles.text2}>{staff}</td>
                                    <td style={styles.text2}>{comment}</td>
                                    <td style={styles.text2}>{stringDateTimeReceipt(timestamp.toDate())}</td>
                                  </tr>
                        })}
                      </tbody>
                    </Table>
                </React.Fragment>
                :null
            }
            <React.Fragment>
                  <h4>{t('mShift.summary')}</h4>
                    <Table striped bordered hover responsive  variant="light"   >
                      <thead  >
                        <tr>
                          <th style={styles.text} >No.</th>
                          <th style={styles.text2} >{t('mShift.list')}</th>
                          <th style={styles.text2} >{t('mShift.qty')}</th>
                        </tr>
                      </thead>
                      <tbody  >
                        <tr  >
                          <td style={styles.text}>1.</td>
                          <td style={styles.text2}>{t('mShift.receive')}</td>
                          <td style={styles.text2}>{formatCurrency(thisTotalNet)}</td>
                        </tr>
                        <tr  >
                          <td style={styles.text}>2.</td>
                          <td style={styles.text2}>{t('mShift.normalReceipt')}</td>
                          <td style={styles.text2}>{thisSelectedQty}</td>
                        </tr>
                        <tr  >
                          <td style={styles.text}>3.</td>
                          <td style={styles.text2}>{t('mShift.voidedReceipt')}</td>
                          <td style={styles.text2}>{thisVoidQty}</td>
                        </tr>
                        <tr  >
                          <td style={styles.text}>4.</td>
                          <td style={styles.text2}>{t('mShift.totalReceipt')}</td>
                          <td style={styles.text2}>{thisSelectedQty+thisVoidQty}</td>
                        </tr>
                        <tr  >
                          <td style={styles.text}>5.</td>
                          <td style={styles.text2}>{t('mShift.salePerReceipt')}</td>
                          <td style={styles.text2}>{formatCurrency(saleRate)}</td>
                        </tr>
                        
                      </tbody>
                    </Table>
                </React.Fragment>
                <React.Fragment>
                  <h4>{t('mShift.payment')}</h4>
                    <Table striped bordered hover responsive  variant="light"   >
                      <thead  >
                        <tr>
                          <th style={styles.text} >No.</th>
                          <th style={styles.text2} >{t('mShift.list')}</th>
                          <th style={styles.text2} >{t('mShift.amount')}</th>
                        </tr>
                      </thead>
                      <tbody  >
                 
                        {thisPayment.map((item, index) => {
                          const { name, amount } = item;
                          return <tr  key={index} >
                                    <td style={styles.text}>{index+1}.</td>
                                    <td style={styles.text2}>{name}</td>
                                    <td style={styles.text2}>{formatCurrency(amount)}</td>
                                  </tr>
                        })}
                        <tr   >
                          {/* <td style={styles.text}>{thisPayment.length+1}.</td> */}
                          <td colSpan={2} style={styles.text2}>{t('mShift.total')}</td>
                          <td style={styles.text2}>{formatCurrency(thisTotalNet)}</td>
                        </tr>
                      </tbody>
                    </Table>
                </React.Fragment>
                <React.Fragment>
                  <h4>อื่นๆ</h4>
                    <Table striped bordered hover responsive  variant="light"   >
                      <thead  >
                        <tr>
                          <th style={styles.text} >No.</th>
                          <th style={styles.text2} >{t('mShift.list')}</th>
                          <th style={styles.text2} >{t('mShift.qty')}</th>
                        </tr>
                      </thead>
                      <tbody  >
                        <tr  >
                          <td style={styles.text}>1.</td>
                          <td style={styles.text2}>ส่วนลดกดลดมือ</td>
                          <td style={styles.text2}>{formatCurrency(totalManualDiscount)}</td>
                        </tr>
                        <tr  >
                          <td style={styles.text}>2.</td>
                          <td style={styles.text2}>ส่วนลดแลกแต้ม</td>
                          <td style={styles.text2}>{formatCurrency(totalPointDiscount)}</td>
                        </tr>
                        <tr  >
                          <td style={styles.text}>3.</td>
                          <td style={styles.text2}>ส่วนลดสินค้า</td>
                          <td style={styles.text2}>{formatCurrency(totalProductDiscount)}</td>
                        </tr>
                        <tr  >
                          <td style={styles.text}>4.</td>
                          <td style={styles.text2}>ภาษีมูลค่าเพิ่ม</td>
                          <td style={styles.text2}>{formatCurrency(thisVat)}</td>
                        </tr>
                      </tbody>
                    </Table>
                </React.Fragment>
                <React.Fragment>
                  <h4>โปรโมชั่น</h4>
                    <Table striped bordered hover responsive  variant="light"   >
                      <thead  >
                        <tr>
                          <th style={styles.text} >No.</th>
                          <th style={styles.text2} >รายการ</th>
                          <th style={styles.text2} >จำนวน</th>
                          <th style={styles.text2} >มูลค่า</th>
                        </tr>
                      </thead>
                      <tbody  >
                 
                        {thisCampaign.map((item, index) => {
                          const { name, qty, discount } = item;
                          return <tr  key={index} >
                                    <td style={styles.text}>{index+1}.</td>
                                    <td >{name}</td>
                                    <td style={styles.text2}>{qty}</td>
                                    <td style={styles.text2}>{formatCurrency(discount)}</td>
                                  </tr>
                        })}
                        <tr   >
                          <td colSpan={2} style={styles.text2}>{t('mShift.total')}</td>
                          <td style={styles.text2}>{summary(thisCampaign,'qty')}</td>
                          <td style={styles.text2}>{formatCurrency(summary(thisCampaign,'discount'))}</td>
                        </tr>
                      </tbody>
                    </Table>
                </React.Fragment>
                <React.Fragment>
                  <h4>{t('mShift.category')}</h4>
                    <Table striped bordered hover responsive  variant="light"   >
                      <thead  >
                        <tr>
                          <th style={styles.text} >No.</th>
                          <th style={styles.text2} >{t('mShift.list')}</th>
                          <th style={styles.text2} >{t('mShift.qty')}</th>
                          <th style={styles.text2} >{t('mShift.cash')}</th>
                        </tr>
                      </thead>
                      <tbody  >
                 
                        {thisCategory.map((item, index) => {
                          const { name, thisQty, thisTotalPrice } = item;
                          return <tr  key={index} >
                                    <td style={styles.text}>{index+1}.</td>
                                    <td >{name}</td>
                                    <td style={styles.text2}>{thisQty}</td>
                                    <td style={styles.text2}>{formatCurrency(thisTotalPrice)}</td>
                                  </tr>
                        })}
                        <tr   >
                          <td colSpan={2} style={styles.text2}>{t('mShift.total')}</td>
                          <td style={styles.text2}>{summary(thisCategory,'thisQty')}</td>
                          <td style={styles.text2}>{formatCurrency(summary(thisCategory,'thisTotalPrice'))}</td>
                        </tr>
                      </tbody>
                    </Table>
                </React.Fragment>
                <React.Fragment>
                  <h4>{t('mShift.product')}</h4>
                    <Table striped bordered hover responsive  variant="light"   >
                      <thead  >
                        <tr>
                          <th style={styles.text} >No.</th>
                          <th style={styles.text2} >{t('mShift.list')}</th>
                          <th style={styles.text2} >{t('mShift.qty')}</th>
                          <th style={styles.text2} >{t('mShift.cash')}</th>
                        </tr>
                      </thead>
                      <tbody  >
                 
                        {normalSort('thisTotalPrice',[...thisProduct]).map((item, index) => {
                          const { name, thisQty, thisTotalPrice } = item;
                          return <tr  key={index} >
                                    <td style={styles.text}>{index+1}.</td>
                                    <td >{name}</td>
                                    <td style={styles.text2}>{thisQty}</td>
                                    <td style={styles.text2}>{formatCurrency(thisTotalPrice)}</td>
                                  </tr>
                        })}
                        <tr   >
                          <td colSpan={2} style={styles.text2}>{t('mShift.total')}</td>
                          <td style={styles.text2}>{summary(thisProduct,'thisQty')}</td>
                          <td style={styles.text2}>{formatCurrency(summary(thisProduct,'thisTotalPrice'))}</td>
                        </tr>
                      </tbody>
                    </Table>
                </React.Fragment>
                <React.Fragment>
                  <h4>{t('mShift.cashier')}</h4>
                    <Table striped bordered hover responsive  variant="light"   >
                      <thead  >
                        <tr>
                          <th style={styles.text} >No.</th>
                          <th style={styles.text2} >{t('mShift.staff2')}</th>
                          <th style={styles.text2} >{t('mShift.sale')}</th>
                        </tr>
                      </thead>
                      <tbody  >
                 
                        {normalSort('totalNet',[...thisCashier]).map((item, index) => {
                          const { cashierName, amount } = item;
                          return <tr  key={index} >
                                    <td style={styles.text}>{index+1}.</td>
                                    <td style={styles.text2}>{cashierName}</td>
                                    <td style={styles.text2}>{formatCurrency(amount)}</td>
                                  </tr>
                        })}
                        <tr   >
                          <td colSpan={2} style={styles.text2}>{t('mShift.total')}</td>
                          <td style={styles.text2}>{formatCurrency(summary(thisCashier,'amount'))}</td>
                        </tr>
                      </tbody>
                    </Table>
                </React.Fragment>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} style={{minWidth:'150px'}} variant="secondary">{t('mShift.close')}</Button>
    </Modal.Footer>
    </Modal>
  );
};

const styles = {
    text : {
      width:'5%',
      textAlign:'center',
      // maxWidth:'12px',
      minWidth:'2rem',
    },
    text2 : {
      width:'20%',
      textAlign:'center',
      minWidth:'120px'
    }
}

export default Modal_Shift;
